// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f689cea","732":"92e53e8c","977":"9959b26d"}[chunkId] + ".chunk.js";
};